import React from 'react';

const Section = (props) => (
    <section className={`pt-12 pb-12 phone-pt-10 phone-pb-10`}>{props.children}</section>
);

export default Section;